// extracted by mini-css-extract-plugin
export default {"modal-actions":"PrivacyPolicy--modal-actions--D68FS","modalActions":"PrivacyPolicy--modal-actions--D68FS","modal":"PrivacyPolicy--modal--7i1ZE","link":"PrivacyPolicy--link--R0Hi7"};